import * as React from "react"
import type { SVGProps } from "react"
const SvgGive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m14.83 20.4 5.94-1.85q-.12-.22-.36-.39a1 1 0 0 0-.54-.16h-5.05q-.67 0-1.07-.05t-.82-.2l-1.43-.48a1 1 0 0 1-.57-.5q-.18-.37-.05-.77a1 1 0 0 1 .48-.59q.36-.18.77-.06l1.05.35q.42.12.96.2.53.07 1.46.1h.28a1 1 0 0 0-.17-.53 1 1 0 0 0-.39-.32L9.48 13h-1.6v5.5zm-.53 1.95-6.43-1.8q-.2.64-.78 1.05-.6.4-1.21.4h-2q-.83 0-1.42-.59-.58-.59-.58-1.41v-7q0-.83.58-1.41.6-.6 1.42-.59h5.6q.17 0 .34.04.18.03.33.09l5.87 2.17q.83.3 1.34 1.05t.52 1.65h2q1.25 0 2.12.82.88.83.88 2.18 0 .55-.3.86-.27.31-.88.52l-6.25 1.95q-.27.1-.57.1t-.58-.08M3.88 20h2v-7h-2zm13-7.8a2 2 0 0 1-1.4-.55l-2.76-2.7a8 8 0 0 1-1.3-1.66 4 4 0 0 1-.54-1.99q0-1.38.96-2.34a3.4 3.4 0 0 1 3.84-.62q.69.34 1.2.91a4 4 0 0 1 1.2-.91 3.4 3.4 0 0 1 3.83.62q.96.96.96 2.34 0 1.08-.52 1.99t-1.3 1.66l-2.78 2.7a2 2 0 0 1-1.4.55m0-2 2.72-2.67q.47-.48.88-1.02.4-.54.4-1.21 0-.55-.38-.92a1.3 1.3 0 0 0-.93-.38q-.35 0-.66.14-.3.14-.54.41l-.72.88a1 1 0 0 1-.77.35 1 1 0 0 1-.78-.36l-.73-.87a1.4 1.4 0 0 0-.53-.41q-.31-.15-.66-.14-.55 0-.93.38-.37.37-.37.92 0 .67.4 1.21.39.54.87 1.02z" />
  </svg>
)
export default SvgGive
